import { BellRing, CalendarClock, CircleAlert, X } from 'lucide-react'
import type { ProjectReminder } from '../lib/reminders'

type Props = {
  reminders: ProjectReminder[]
  onClose: () => void
  onOpenProject: (projectId: string) => void
}

const iconForTone = {
  urgent: CircleAlert,
  attention: BellRing,
  planned: CalendarClock,
}

export function ReminderDrawer({ reminders, onClose, onOpenProject }: Props) {
  return <div className="drawer-backdrop reminder-backdrop" role="presentation" onMouseDown={onClose}>
    <aside className="reminder-drawer" role="dialog" aria-modal="true" aria-labelledby="reminder-title" onMouseDown={(event) => event.stopPropagation()}>
      <header><div><span className="eyebrow">RAPPELS</span><h2 id="reminder-title">À surveiller</h2></div><button className="icon-button" onClick={onClose} aria-label="Fermer" type="button"><X size={19} /></button></header>
      {reminders.length ? <div className="reminder-list">{reminders.map((reminder) => {
        const Icon = iconForTone[reminder.tone]
        return <button className={`reminder-row ${reminder.tone}`} key={reminder.id} onClick={() => onOpenProject(reminder.projectId)} type="button">
          <Icon size={19} />
          <span><small>{reminder.projectName}</small><strong>{reminder.title}</strong><em>{reminder.stepName}</em>{reminder.detail ? <i>{reminder.detail}</i> : null}</span>
        </button>
      })}</div> : <div className="reminder-empty"><BellRing size={23} /><strong>Rien à signaler</strong><span>Les rappels apparaîtront uniquement à partir des informations renseignées.</span></div>}
    </aside>
  </div>
}
